import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'

import './CustomCheckbox.sass'

const CustomCheckbox = ({ checked, color, className, ...rest }) => (
	<Form.Check
		type="checkbox"
		className={`custom-checkbox ${className || ''}`}
		checked={checked}
		style={{ "--custom-checkbox-bg": checked ? color : '#fff' }}
		{...rest}
	/>
)

CustomCheckbox.propTypes = {
	checked: PropTypes.bool.isRequired,
	color: PropTypes.string.isRequired,
}

export default CustomCheckbox
